<template>

    <div id="videoTest"></div>

</template>

<script>

    import Clappr from 'clappr';
    import ClapprGoogleImaHtml5PrerollPlugin from 'clappr-google-ima-html5-preroll-plugin';

	export default {
		name: 'Video-Page-Test',
		data () {
			return {
				player: null,
            }
		},
		mounted() {
			this.initVid();
		},
		methods: {
            initVid() {
                var playerElement = document.getElementById("videoTest")

                this.player = new Clappr.Player({
                    source: "https://s3.amazonaws.com/media-preview.livestormsvideo.com/videos/2018/10/11/5f327b58477a8b6a61684a0973a1c148/5f327b58477a8b6a61684a0973a1c148.mp4",
                    poster: "https://media-preview.livestormsvideo.com/thumbnails/2018/10/11/5f327b58477a8b6a61684a0973a1c148-00001.png",
                    autoPlay: false,
                    plugins: {
                        // core: [ClapprGoogleImaHtml5PrerollPlugin],
                    },
                    width: "100%",
                    height: "100%",
                    // googleImaHtml5PrerollPlugin: {
                    //     tag: 'http://googleads.g.doubleclick.net/pagead/ads?ad_type=video&client=ca-video-pub-4968145218643279&videoad_start_delay=0&description_url=http%3A%2F%2Fwww.google.com&max_ad_duration=40000&adtest=on', // VAST tag URL (or false to disable plugin)
                    //     vpaid: 0, // Default is 0 (0 is DISABLED, 1 is ENABLED and 2 is INSECURE)
                    //     autostart: false, // Default is true
                    //     // events: { /* Event map */ },
                    //     // imaLoadTimeout: 3000, // Default is 6000 milliseconds
                    //     // nonLinearDuration: 20000, // Default is 15000 milliseconds
                    //     // maxDuration: 30000, // Default is false (DISABLED)
                    //     // locale: 'fr', // Any two-letter ISO 639-1 code. Default is false (Do not setup)
                    //     // disableLoader: true, // Default is false (Loader is enabled)
                    // },
                })
                // console.log('ok')

                this.player.attachTo(playerElement)
            }
		},
        beforeDestroy() {
            // console.log('destroying')
            this.player.stop()
            this.player.destroy()
            // console.log('destroyed')
        }
	}
</script>

<style>
	/* #videoHolder {
		width: 100%;
		height: 100%;
	}

    .video {
        width: 100%;
        height: 100%;
    } */


</style>
